import React, {useState, useContext} from 'react';
import SavedSearchesEntityFilters from './SavedSearchEntityFilters';
import {Input} from 'reactstrap';
import {SavedSearchContext} from 'contexts/SavedSearchContext';
import SentimentFilters from './SentimentFilters';
import SocialFilters from './SocialFilters';

const ListFilters = (props) => {

    const {
        activeSavedSearchSort, setActiveSavedSearchSort, selectedEntities, savedSearchSocialFilters,
        setSelectedEntities, savedSearchPeriodFilter, setSavedSearchPeriodFilter, savedSearchSentimentFilters,
        savedSearchSentimentCount, savedSearchSocialCount, setSavedSearchSentimentFilters, setSavedSearchSocialFilters,
        updatingSavedSearchCount, sliderVisible
    } = useContext(SavedSearchContext);


    const {entities, entitiesLoading, activeView, toggleSocialFilters, toggleSentimentFilters, updating,
        toggleAllEntities, handleEntitySelect} = props;

    const [isChanging, setIsChanging] = useState(false);
    const [tempPeriod, setTempPeriod] = useState(5);

    const periodChangingInitialization = () => {
        setIsChanging(true);
        setTempPeriod(savedSearchPeriodFilter.toString());
    };

    const confirmPeriodChange = () => {
        if(parseInt(tempPeriod, 10) !== savedSearchPeriodFilter) {
            setSavedSearchPeriodFilter(parseInt(tempPeriod, 10));
        }
        setIsChanging(false);
    };

    const handlePeriodChange = (value) => {
        setTempPeriod(value);
    };

    return (
        <div className="home-page-filters">
            <div className="home-page-filters__upper">
                {sliderVisible &&
                <div className="home-page-filters__filter-container mt-2">
                    <div style={{fontWeight: '700'}}>Period</div>
                    <div className="days-slider">
                        <input
                            style={{width: '200px', cursor: 'pointer', padding: '10px 0'}}
                            min="1"
                            max="30"
                            step="1"
                            onMouseDown={periodChangingInitialization}
                            onMouseUp={confirmPeriodChange}
                            value={isChanging ? tempPeriod : savedSearchPeriodFilter}
                            onChange={e => handlePeriodChange(e.target.value)}
                            disabled={updating}
                            type="range"
                        />
                        <div className="days-slider-label" style={{
                            position: 'relative',
                            left: `${isChanging ? 3 + (tempPeriod - 1) * 6 : 3 + (savedSearchPeriodFilter - 1) * 6}px`,
                            top: '2px',
                        }}>
                            <span>
                                {isChanging ?
                                    tempPeriod == '31' ? '30+' : tempPeriod
                                    :
                                    savedSearchPeriodFilter === 31 ? '30+' : savedSearchPeriodFilter
                                } {isChanging ?
                                tempPeriod == '1' ? 'day' : 'days'
                                :
                                savedSearchPeriodFilter === 1 ? 'day' : 'days'
                            }
                            </span>
                        </div>
                    </div>
                </div>
                }

                <SentimentFilters
                    toggleSentimentFilters={toggleSentimentFilters}
                    sentimentFilters={savedSearchSentimentFilters}
                    updatingCount={entitiesLoading || updatingSavedSearchCount}
                    sentimentCount={savedSearchSentimentCount}
                />

                <SocialFilters
                    socialFilters={savedSearchSocialFilters}
                    toggleSocialFilters={toggleSocialFilters}
                    activeView={activeView}
                    updating={entitiesLoading || updatingSavedSearchCount}
                    socialCount={savedSearchSocialCount}
                />

                <div className="home-page-filters__filter-container w-100 mb-2" style={{marginTop: '20px'}}>
                    <div style={{fontWeight: '700'}}>Sort by</div>
                        <Input
                            className="home-page-filters__sort-dropdown"
                            onChange={(e) => setActiveSavedSearchSort(e.target.value)}
                            value={activeSavedSearchSort}
                            type="select" name="sorting"
                        >
                            <option value={0}>Date (Newest to Oldest)</option>
                            <option value={1}>Date (Oldest to Newest)</option>
                            <option value={2}>Influence (High to Low)</option>
                            <option value={3}>Influence (Low to High)</option>
                        </Input>
                </div>

            </div>
            <div className="home-page-filters__lower">
                <SavedSearchesEntityFilters
                    entities={entities}
                    activeEntities={selectedEntities}
                    setActiveEntities={setSelectedEntities}
                    entitiesLoading={entitiesLoading}
                    updating={updating}
                    handleEntitySelect={handleEntitySelect}
                    toggleAllEntities={toggleAllEntities}
                />
            </div>
        </div>
    );
};

export default ListFilters;
